const ALLOWED_GROUP_BY_KEYS = ['facility', 'sub_account', 'department'];
const ALLOWED_SPECIAL_PROJECT_GROUP_BY_KEYS = ['sub_account', 'department'];

const normalizeGroupByConfig = (value) => {
    if (!value) return [];

    if (Array.isArray(value)) {
        return value
            .map((item) => String(item || '').trim().toLowerCase())
            .filter(Boolean)
            .filter((item) => ALLOWED_GROUP_BY_KEYS.includes(item));
    }

    return String(value)
        .split(',')
        .map((item) => item.trim().toLowerCase())
        .filter(Boolean)
        .filter((item) => ALLOWED_GROUP_BY_KEYS.includes(item));
};

const getGroupValue = (appointment, key) => {
    const details = appointment?.appointment_details || {};

    switch (key) {
        case 'facility':
            return details?.facility?.facility_name
                || details?.facility_name
                || appointment?.facility?.facility_name
                || appointment?.facility_name
                || null;
        case 'sub_account':
            return details?.sub_account?.name
                || details?.sub_account_name
                || details?.subaccount_name
                || appointment?.sub_account?.name
                || appointment?.sub_account_name
                || appointment?.subaccount_name
                || appointment?.subclient?.subaccount_name
                || appointment?.subclient?.name
                || null;
        case 'department':
            return details?.department?.department_name
                || details?.department_name
                || appointment?.department?.department_name
                || appointment?.department_name
                || null;
        default:
            return null;
    }
};

const getDisplayLabel = (key, value) => {
    if (value === null || value === undefined || value === '') {
        if (key === 'facility') return 'No Facility';
        if (key === 'sub_account') return 'No Sub Account';
        if (key === 'department') return 'No Department';
        return 'N/A';
    }

    return value;
};

// export const getInvoiceGroupByConfig = (appointments = [], fallbackGroupByValue = '') => {
//     const fromAppointment = appointments.find((appointment) => appointment?.appointment_details?.invoice_group_by);
//     const value = fromAppointment?.appointment_details?.invoice_group_by || fallbackGroupByValue || '';

//     return normalizeGroupByConfig(value);
// };

export const getInvoiceGroupByConfig = (groupByValue = '') => {
    return normalizeGroupByConfig(groupByValue);
};

export const buildInvoiceGroups = (appointments = [], groupByValue = '') => {
    const groupKeys = normalizeGroupByConfig(groupByValue);

    if (!groupKeys.length) {
        return [{ key: 'ungrouped', label: null, appointments }];
    }

    const groupedMap = new Map();

    appointments.forEach((appointment) => {
        const groupKey = groupKeys
            .map((key) => getGroupValue(appointment, key))
            .join('::');

        const label = groupKeys
            .map((key) => getDisplayLabel(key, getGroupValue(appointment, key)))
            .join(' - ');

        if (!groupedMap.has(groupKey)) {
            groupedMap.set(groupKey, {
                key: groupKey,
                label,
                appointments: [],
            });
        }

        groupedMap.get(groupKey).appointments.push(appointment);
    });

    return Array.from(groupedMap.values());
};

const normalizeSpecialProjectGroupBy = (value) => {
    const values = Array.isArray(value) ? value : String(value || '').split(',');

    return values
        .map((item) => String(item || '').trim().toLowerCase())
        .filter((item) => ALLOWED_SPECIAL_PROJECT_GROUP_BY_KEYS.includes(item));
};

const getSpecialProjectGroupValue = (project, key) => {
    switch (key) {
        case 'department':
            return project?.translation?.translation_details?.department?.department_name || null;
        case 'sub_account':
            return project?.translation?.subclient?.subaccount_name || null;
        default:
            return null;
    }
};

const getSpecialProjectDisplayLabel = (key, value) => {
    if (value === null || value === undefined || value === '') {
        return key === 'department' ? 'No Department' : 'No Sub Account';
    }

    return value;
};

export const getSpecialProjectGroupByConfig = (groupByValue = '') => {
    return normalizeSpecialProjectGroupBy(groupByValue);
};

export const buildSpecialProjectGroups = (projects = [], groupByValue = '') => {
    const groupKeys = normalizeSpecialProjectGroupBy(groupByValue);

    if (!groupKeys.length) {
        return [{ key: 'ungrouped', label: null, projects }];
    }

    const groupedMap = new Map();

    projects.forEach((project) => {
        const values = groupKeys.map((key) => getSpecialProjectGroupValue(project, key));
        const groupKey = values.map((value) => value ?? '').join('::');
        const label = values
            .map((value, index) => getSpecialProjectDisplayLabel(groupKeys[index], value))
            .join(' - ');

        if (!groupedMap.has(groupKey)) {
            groupedMap.set(groupKey, { key: groupKey, label, projects: [] });
        }

        groupedMap.get(groupKey).projects.push(project);
    });

    return Array.from(groupedMap.values());
};
